import { render, staticRenderFns } from "./EcPieChart.vue?vue&type=template&id=439b02a8&"
import script from "./EcPieChart.vue?vue&type=script&lang=ts&"
export * from "./EcPieChart.vue?vue&type=script&lang=ts&"
import style0 from "./EcPieChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports